<div>
    <div [ngClass]="{'disabled': isDisabled}">
        <ng-content></ng-content>
    </div>
</div>
